import { createFileRoute, Navigate } from '@tanstack/react-router'
import { observer } from 'mobx-react'

import Loading from '~/components/loading'
import { useRootStore } from '~/store/RootStore'

const IndexPage = observer(() => {
  const { app } = useRootStore()

  if (app.isAuthenticated) {
    return <Navigate to="/home" />
  }
  return <Loading />
})

export const Route = createFileRoute('/')({
  component: IndexPage,
})
